const ITEMS = [
  "CEMENT", "STEEL", "MINING", "FABRICATION", "WEAR PLATES", "HARDOX",
  "CCO LINERS", "HARDFACING", "BUCKET RECONDITIONING", "STORAGE TANKS",
  "RIYADH", "JUBAIL", "YANBU", "DAMMAM", "KSA",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-seam bg-iron py-5" data-testid="industrial-marquee">
      <div className="flex w-max animate-marquee items-center gap-8 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-8 font-display text-xl font-bold uppercase tracking-[0.2em] text-cadmium/70">
            {item}
            <span className="h-1.5 w-1.5 rotate-45 bg-spark" />
          </span>
        ))}
      </div>
    </div>
  );
};
